// extracted by mini-css-extract-plugin
export var option = "_2w-0";
export var optionSelected = "_2w-1 _2w-0";
export var optionUnselected = "_2w-2 _2w-0";
export var radioInner = "_2w-5";
export var radioOuter = "_2w-3";
export var radioOuterSelected = "_2w-4 _2w-3";